import { ControlPropertyType } from '../../../enums';

export const PasswordInputProperty = {
  ...ControlPropertyType,
  FillType: 'fillType',
  MinLength: 'minLength',
};

export default {
  PasswordInputProperty,
};
